import { ThumbDown as ThumbDownIcon } from '@mui/icons-material';

const ThumbDown = (): JSX.Element => <ThumbDownIcon fontSize="inherit" />;

export default ThumbDown;
